<template>
  <div class="content">
      <div class="block block-rounded block-fx-shadow mb-3">
        <div class="block-header">
          <h3 class="block-title">{{ $t('roles.index') }}</h3>
          <div class="block-options">
            <b-btn v-b-modal.addrole size="sm" variant="primary">{{ $t('roles.add') }}</b-btn>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-bordered  table-hover display">
            <thead>
              <tr>
                <th>#</th>
                <th>{{ $t('app.id') }}</th>
                <th>{{ $t('app.display_name') }}</th>
                <th>{{ $t('app.name') }}</th>
                <th>{{ $t('app.desc') }}</th>
                <th>{{ $t('app.action') }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="!loadRoles">
                <tr v-for="(role, index) in roles" :key="role.id">
                  <td>{{index+1}}</td>
                  <td>{{role.id}}</td>
                  <td>{{role.display_name}}</td>
                  <td>{{role.name}}</td>
                  <td>{{role.description}}</td>
                  <td>
                    <div class="btn-group">
                      <button @click.prevent="initUpdate(index)" class="btn btn-primary btn-sm" title="Редактировать">
                        <i class="fa fa-edit"></i>
                      </button>
                      <button @click.prevent="handleDelete(role.id)" class="btn btn-danger btn-sm" title="Удалить">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </template>
              <tr v-if="loadRoles">
                <td colspan="6">
                  <loader-wave/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <b-modal
        id="updaterole"
        size="lg"
        :title="$t('roles.edit')"
        ref="modalUpdateRole"
        @ok="handleUpdate"
        @shown="fetchRoles"
        :ok-title="$t('buttons.save')"
        :cancel-title="$t('buttons.cancel')"
      >
          <div class="form-group">
              <label for="UpdateName" class="col-form-label">{{ $t('app.name') }}</label>
              <pre class="form-control"><strong>{{update_role.name}}</strong></pre>
          </div>
          <div class="form-group">
              <label for="updatedisplayname" class="col-form-label">{{ $t('app.display_name') }}</label>
              <input type="text" class="form-control" v-model="update_role.display_name" :class="{'is-invalid': update_errors.display_name }" id="updatedisplayname">
              <span v-if="update_errors.display_name" class="invalid-feedback">
                  <strong>{{update_errors.display_name ? update_errors.display_name[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group">
              <label for="updatedescription" class="col-form-label">{{ $t('app.desc') }}</label>
              <input type="text" class="form-control" v-model="update_role.description" :class="{'is-invalid': update_errors.description }" id="updatedescription">
              <span v-if="update_errors.description" class="invalid-feedback">
                  <strong>{{update_errors.description ? update_errors.description[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group">
              <label for="updatedescription" class="col-form-label">{{ $t('permissions.index') }}</label>
              <div class="row">
                <div
                  v-for="(permission, index) in permissions"
                  :class="{ 'col-md-12': permissions.length <= 12, 'col-md-6': permissions.length <= 24, 'col-md-4': permissions.length >= 24,}"
                  :key="index"
                >
                  <div class="custom-control custom-checkbox mb-3" >
                    <input type="checkbox" class="custom-control-input" :id="`permission-${permission.id}`" v-model="update_role.selectedPermissions" :value="permission.id">
                    <label class="custom-control-label" :for="`permission-${permission.id}`" :aria-describedby="`permisHelp-${permission.id}`" >{{permission.display_name}}</label>
                    <small :id="`permisHelp-${permission.id}`" class="form-text text-muted">{{permission.name}}</small>
                  </div>
                </div>
              </div>
          </div>
      </b-modal>

      <b-modal
        id="addrole"
        size="lg"
        :title="$t('roles.add')"
        ref="modalAddRole"
        @ok="handleStore"
        @shown="fetchRoles"
        :ok-title="$t('buttons.ok')"
        :cancel-title="$t('buttons.cancel')"
      >
          <div class="form-group">
              <label for="storename" class="col-form-label">{{ $t('app.name') }}</label>
              <input type="text" class="form-control" v-model="role.name" :class="{'is-invalid': errors.name }" id="storename">
              <span v-if="errors.name" class="invalid-feedback">
                  <strong>{{errors.name ? errors.name[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group">
              <label for="storedisplayname" class="col-form-label">{{ $t('app.display_name') }}</label>
              <input type="text" class="form-control" v-model="role.display_name" :class="{'is-invalid': errors.display_name }" id="storedisplayname">
              <span v-if="errors.display_name" class="invalid-feedback">
                  <strong>{{errors.display_name ? errors.display_name[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group">
              <label for="storedescription" class="col-form-label">{{ $t('app.desc') }}</label>
              <input type="text" class="form-control" v-model="role.description" :class="{'is-invalid': errors.description }" id="storedescription">
              <span v-if="errors.description" class="invalid-feedback">
                  <strong>{{errors.description ? errors.description[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group">
              <label for="updatedescription" class="col-form-label">{{ $t('permissions.index') }}</label>
              <div class="row">
                <div
                  v-for="(permission, index) in permissions"
                  :class="{ 'col-md-12': permissions.length <= 12, 'col-md-6': permissions.length <= 24, 'col-md-4': permissions.length >= 24,}"
                  :key="index"
                >
                  <div class="custom-control custom-checkbox mb-3" >
                    <input type="checkbox" class="custom-control-input" :id="`permission-${permission.id}`" v-model="role.selectedPermissions" :value="permission.id">
                    <label class="custom-control-label" :for="`permission-${permission.id}`" :aria-describedby="`permisHelp-${permission.id}`" >{{permission.display_name}}</label>
                    <small :id="`permisHelp-${permission.id}`" class="form-text text-muted">{{permission.name}}</small>
                  </div>
                </div>
              </div>
          </div>
      </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      roles: [],
      permissions: [],
      errors: {},
      update_errors: {},
      role: {
        selectedPermissions: [],
      },
      update_role: {
        selectedPermissions: [],
      },
      isProcessing: false,
      loadRoles: false,
    };
  },
  mounted() {
    this.fetchRoles();
    this.fetchPermissions();
  },
  methods: {
    fetchRoles() {
      this.loadRoles = true;
      window.axios.get('/admin/roles')
        .then((res) => {
          this.roles = res.data.roles;
          this.loadRoles = false;
        });
    },

    fetchPermissions() {
      window.axios.get('/admin/permissions')
        .then((res) => {
          this.permissions = res.data.permissions;
        });
    },

    clearUpdateModal() {
      this.update_role = {};
    },

    clearModal() {
      this.role = {
        selectedPermissions: [],
      };
    },

    initUpdate(index) {
      this.update_errors = {};
      this.update_role = this.roles[index];
      this.update_role.selectedPermissions = Object.keys(this.update_role.permissions).map(i => this.update_role.permissions[i].id);
      this.$refs.modalUpdateRole.show();
    },

    handleStore(evt) {
      evt.preventDefault();
      this.storeRole();
      this.isProcessing = true;
    },

    handleUpdate(evt) {
      evt.preventDefault();
      this.updateRole();
      this.isProcessing = true;
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deleteRole(id);
        }
      });
    },

    storeRole() {
      window.axios.post(`/admin/roles`, this.role)
        .then((res) => {
          if (res.status === 201) {
            this.$refs.modalAddRole.hide();
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.clearModal();
            this.fetchRoles();
          }
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    updateRole() {
      window.axios.put(`/admin/roles/${this.update_role.id}`, this.update_role)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.modalUpdateRole.hide();
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.clearUpdateModal();
            this.fetchRoles();
          }
        })
        .catch((err) => {
          this.update_errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    deleteRole(id) {
      window.axios.delete(`/admin/roles/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchRoles();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
